import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import axios from 'axios'
import { useHistory } from 'react-router-dom';
import jwt, { decode } from 'jsonwebtoken'
import Swal from 'sweetalert2'
import Header from '../Element/Header'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  image: {
    width: 128,
    height: 128,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    alignSelf: 'center'
  },
  vacancyContainer: {
    flexDirection: 'column'
  },
  modal: {
    position: 'absolute',
    top: '10%',
    left: '10%',
    overflow: 'scroll',
    height: '100%',
    display: 'block'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    flexDirection: 'column',
    display: 'flex'
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
}));


async function fetchCompany(history) {
  try {
    const token = localStorage.getItem('token');
    const result = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API}/company/read/scholar`,
      headers: { token }
    })

    return result
  } catch (error) {
    history.push({
      pathname: '/participant/login'
    })
  }
}

async function fetchBiodata(history) {
  try {
    const token = localStorage.getItem('token');
    var decoded = jwt.verify(token, process.env.REACT_APP_SECRET_PARTICIPANT);
    const result = await axios({
      method: 'post',
      data: {
        email: decoded.id
      },
      url: `${process.env.REACT_APP_API}/participant/biodata/read`,
      headers: { token }
    })

    return result
  } catch (error) {
    window.localStorage.clear()
    history.push('/participant/login')
  }
}

async function updateBiodata(expecSalary, nationality, softSkills, hardSkills, hobbiesInterest, orgExp, educationNonFormal, currentRole, noticePeriod, setOpen) {
  const token = localStorage.getItem('token');
  let decoded = jwt.verify(token, process.env.REACT_APP_SECRET_PARTICIPANT);
  const result = await axios({
    method: 'post',
    data: {
      expec_salary: expecSalary,
      nationality: nationality,
      soft_skills: softSkills,
      hard_skills: hardSkills,
      hobbies_interest: hobbiesInterest,
      education_non_formal: educationNonFormal,
      current_role: currentRole,
      notice_period: noticePeriod,
      org_exp: orgExp,
      participant_id: decoded.id
    },
    url: `${process.env.REACT_APP_API}/company/update`,
    headers: { token }
  })

  if (result.data[0] === 1) {
    setOpen(false);
    return Swal.fire({
      icon: 'success',
      title: 'Success',
      showConfirmButton: false,
      timer: 1500
    })
  } else {
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: `failed update`,
    })
  }
}

async function logOut(history) {
  window.localStorage.clear()
  history.push('/participant/login')
}

export default function ScholarParticipant() {
  const history = useHistory()
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [expandedDetails, setExpandedDetails] = React.useState(false);
  const [company, setCompany] = useState([])
  const [expecSalary, setExpecSalary] = useState(null)
  const [nationality, setNationality] = useState(null)
  const [softSkills, setSoftSkills] = useState(null)
  const [hardSkills, setHardSkills] = useState(null)
  const [hobbiesInterest, setHobbiesInterest] = useState(null)
  const [orgExp, setOrgExp] = useState(null)
  const [educationNonFormal, setEducationNonFormal] = useState(null)
  const [currentRole, setCurrentRole] = useState(null)
  const [noticePeriod, setNoticePeriod] = useState(null)
  const [open, setOpen] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleChangeDetails = (panel) => (event, isExpanded) => {
    setExpandedDetails(isExpanded ? panel : false);
  };

  const handleChangeExpecSalary = (event) => {
    setExpecSalary(event.target.value);
  }

  const handleChangeNationality = (event) => {
    setNationality(event.target.value)
  }

  const handleChangeSoftSkills = (event) => {
    setSoftSkills(event.target.value)
  }

  const handleChangeHardSkills = (event) => {
    setHardSkills(event.target.value)
  }

  const handleChangeHobbiesInterest = (event) => {
    setHobbiesInterest(event.target.value)
  }

  const handleChangeorgExp = (event) => {
    setOrgExp(event.target.value)
  }

  const handleChangeEducationNonFormal = (event) => {
    setEducationNonFormal(event.target.value)
  }

  const handleChangeCurrentRole = (event) => {
    setCurrentRole(event.target.value)
  }

  const handleChangeNoticePeriod = (event) => {
    setNoticePeriod(event.target.value)
  }

  const handleOpen = (value) => {
    // let params = [expecSalary, nationality, softSkills, hardSkills, hobbiesInterest, orgExp, educationNonFormal]
    // for (let index = 0; index < params.length; index++) {
    //   const element = params[index];
    //   if (element == null || element == '') {
    //     return setOpen(true);
    //   }
    // }

    Swal.fire({
      title: 'Kamu yakin ?',
      text: "Biodata akan dikirimkan ke perusahaan yang dimaksud",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem('token');
        let decoded = jwt.verify(token, process.env.REACT_APP_SECRET_PARTICIPANT);
        axios({
          method: 'post',
          url: `${process.env.REACT_APP_API}/company/apply`,
          data: {
            participantId: decoded.id,
            company_vacancyId: value.id
          },
          headers: { token }
        })
          .then(async function (response) {
            await Swal.fire({
              icon: 'success',
              title: `Apply berhasil untuk posisi ${value.position}`,
              showConfirmButton: false,
              timer: 1500
            })
            window.location.reload();
          })
          .catch(function (error) {
            if (error.response.status == 409) {
              return Swal.fire({
                icon: 'error',
                title: 'Sudah Apply'
              })
            }
            return Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: `${error}`,
            })
          });
      }
    })
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(async () => {
    let companyResult = await fetchCompany(history)
    let biodataResult = await fetchBiodata(history)
    console.log(companyResult)
    if (companyResult != undefined) {
      setCompany(companyResult.data)
      setExpecSalary(biodataResult.data.expec_salary)
      setNationality(biodataResult.data.nationality)
      setSoftSkills(biodataResult.data.soft_skills)
      setHardSkills(biodataResult.data.hard_skills)
      setHobbiesInterest(biodataResult.data.hobbies_interest)
      setOrgExp(biodataResult.data.org_exp)
      setEducationNonFormal(biodataResult.education_non_formal)
      setCurrentRole(biodataResult.current_position)
      setNoticePeriod(biodataResult.notice_period)
    }

  }, [])

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Header />

      {/* <Button variant="contained" color="primary" onClick={() => logOut(history)} >
        Log Out
      </Button> */}
      {
        company.length === 0 ?
          <h1>Mohon Maaf untuk saat ini masih belum tersedia</h1> : null
      }
      <Container maxWidth="md">
        {company.map((value, index) => {
          return (
            <Accordion expanded={expanded === index} onChange={handleChange(index)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography className={classes.heading}>
                  <img alt="complex" src={`${process.env.REACT_APP_API}/${value.logo}`} style={{
                    maxHeight: '50px',
                    maxWidth: '150px'
                  }} />
                </Typography>
                <Typography className={classes.secondaryHeading}>{value.display_name ? value.display_name : value.name}</Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.vacancyContainer}>
                {value.company_vacancies.map((value, index) => {
                  return (
                    <Accordion expanded={expandedDetails === index} onChange={handleChangeDetails(index)}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography className={classes.secondaryHeading}>{value.position.toUpperCase()}</Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes.vacancyContainer}>
                        <div style={{ marginBottom: '4%' }}>
                          <Typography>
                            - <b>Requirement</b>
                          </Typography>
                          {value.requirement ? value.requirement.split("\n").map((i, key) => {
                            return (
                              <Typography key={key}>
                                {i}
                              </Typography>
                            )
                          }): null}
                          <Typography>
                            - <b>Description</b>
                          </Typography>
                          {value.description ? value.description.split("\n").map((i, key) => {
                            return (
                              <Typography key={key}>
                                {i}
                              </Typography>
                            )
                          }) : null}
                          <Button variant="contained" color="primary" onClick={() => handleOpen(value)}>
                            Apply
                          </Button>
                        </div>
                      </AccordionDetails>
                    </Accordion>)
                })}
              </AccordionDetails>
            </Accordion>
          )
        })}
      </Container>


      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Container maxWidth="sm" className={classes.paper} >
            <TextField id="outlined-basic" label="Expected Salary" variant="outlined" value={expecSalary} onChange={handleChangeExpecSalary} />
            <TextField id="outlined-basic" label="Nationality" variant="outlined" value={nationality} onChange={handleChangeNationality} />
            <TextField
              id="outlined-basic_1"
              label="Soft Skills"
              variant="outlined"
              multiline
              rows={4}
              value={softSkills}
              onChange={handleChangeSoftSkills}
            />
            <TextField
              id="outlined-basic_2"
              label="Hard Skills"
              variant="outlined"
              multiline
              rows={4}
              value={hardSkills}
              onChange={handleChangeHardSkills}
            />
            <TextField
              id="outlined-basic"
              label="Hobbies Interest"
              variant="outlined"
              multiline
              rows={4}
              value={hobbiesInterest}
              onChange={handleChangeHobbiesInterest}
            />
            <TextField
              id="outlined-basic"
              label="Organization Experience"
              variant="outlined"
              multiline
              rows={4}
              value={orgExp}
              onChange={handleChangeorgExp}
            />
            <TextField
              id="outlined-basic"
              label="Education Non Formal"
              variant="outlined"
              multiline
              rows={4}
              value={educationNonFormal}
              onChange={handleChangeEducationNonFormal}
            />
            <TextField
              id="outlined-basic"
              label="Current Role"
              variant="outlined"
              multiline
              rows={4}
              value={currentRole}
              onChange={handleChangeCurrentRole}
            />
            <TextField
              id="outlined-basic"
              label="Notice Period"
              variant="outlined"
              multiline
              rows={4}
              value={noticePeriod}
              onChange={handleChangeNoticePeriod}
            />
            <Button variant="contained" color="primary" onClick={() =>
              updateBiodata(
                expecSalary,
                nationality,
                softSkills,
                hardSkills,
                hobbiesInterest,
                orgExp,
                educationNonFormal,
                currentRole,
                noticePeriod,
                setOpen)}>
              Update
            </Button>
          </Container>
        </Fade>
      </Modal>
    </div>
  );
}